import React from 'react';
import 'Lessons/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const ShowStream = angularDirectiveToReact('showStream', {
    lessonId: '<',
    streamId: '<',
    chapterIndex: '<',
    mode: '<',
});

export const ShowStreamComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        streamId: string;
        lessonId: string;
        chapterIndex: string;
        mode?: string;
    }>();

    return <ShowStream key={key} {...params} />;
};
